import { render, staticRenderFns } from "./EmbarcacaoForm.vue?vue&type=template&id=47239826"
import script from "./EmbarcacaoForm.vue?vue&type=script&lang=js"
export * from "./EmbarcacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports